module.exports = __webpack_public_path__ + "dc5b78c38f7b300b8188b25b831ff454.svg";